import {
  ExtractAtomicOperationFromDefinition,
  createAtomicOperationDefinition,
} from "../../atomic-operations";
import { ExploreSpecSessionStateId } from "../../idTypeBrands";
import { SemanticCap } from "../../semanticCaps.js";

import { ExploreSpecSessionStateUpdatableFields } from "./commonExploreSpecSessionStateTypes";
import { CREATE_EXPLORE_SPEC_SESSION_STATE } from "./createExploreSpecSessionState";

const UPDATE_EXPLORE_SPEC_SESSION_STATE_TYPE =
  "UPDATE_EXPLORE_SPEC_SESSION_STATE" as const;

export const UPDATE_EXPLORE_SPEC_SESSION_STATE =
  createAtomicOperationDefinition({
    type: UPDATE_EXPLORE_SPEC_SESSION_STATE_TYPE,
    readAuth: {
      kind: "hasSemanticCap",
      cap: SemanticCap.VIEW_APP_SESSION,
    },
    writeAuth: {
      kind: "hasSemanticCapOnIdArg",
      cap: SemanticCap.EDIT_APP_SESSION,
      idArg: "exploreSpecSessionStateId",
      idType: "ExploreSpecSessionState",
    },
    conflictId: (op) =>
      `${UPDATE_EXPLORE_SPEC_SESSION_STATE_TYPE}-${op.payload.exploreSpecSessionStateId}-${op.payload.key}`,
    creationId: (op) =>
      `${CREATE_EXPLORE_SPEC_SESSION_STATE.type}-${op.payload.exploreSpecSessionStateId}`,
    create: <K extends keyof ExploreSpecSessionStateUpdatableFields>(args: {
      exploreSpecSessionStateId: ExploreSpecSessionStateId;
      key: K;
      value: ExploreSpecSessionStateUpdatableFields[K];
      shouldRunCell?: boolean;
    }) => ({
      type: UPDATE_EXPLORE_SPEC_SESSION_STATE_TYPE,
      payload: {
        ...args,
      },
    }),
    logSafe: ["exploreSpecSessionStateId", "key", "shouldRunCell"],
  });

export type UPDATE_EXPLORE_SPEC_SESSION_STATE =
  ExtractAtomicOperationFromDefinition<
    typeof UPDATE_EXPLORE_SPEC_SESSION_STATE
  >;
